export const home_images = [
  {
    url: 'images/homeDirectory/1.webp',
    caption: 'Eliova Build >> CONCEPTS MIAMI',
  },
  {
    url: 'images/homeDirectory/2.jpg',
    caption: 'Eliova Build >> CHALET WENTWORTH',
  },
  {
    url: 'images/homeDirectory/3.webp',
    caption: 'Eliova Build >> CONCEPTS BOSTON HQ',
  },
  {
    url: 'images/homeDirectory/4.avif',
    caption: 'Eliova Build >> CONCEPTS NEW YORK',
  },
  {
    url: 'images/homeDirectory/5.jpg',
    caption: 'Eliova Build >> LES CHOCOLATS DE CHLOÉ',
  },
];